import { render } from "./beneficiary_id_order_by_mitchell_for_management_table.vue?vue&type=template&id=4932f418&scoped=true"
import script from "./beneficiary_id_order_by_mitchell_for_management_table.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_order_by_mitchell_for_management_table.vue?vue&type=script&lang=js"

import "./beneficiary_id_order_by_mitchell_for_management_table.vue?vue&type=style&index=0&id=4932f418&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4932f418"]])

export default __exports__